 // Filter points by tag utility function
export const filterPointsByTag = (filteredPoints, tags) => {
  return filteredPoints.filter((point) => {
    return tags.every(item => point.pointTags.includes(item.title.trim()))
  })
}
